
import React, { useEffect } from 'react';
import { useLanguage } from "@/hooks/useLanguage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { NewsListItem } from "./NewsListItem";
import { Newspaper } from "lucide-react";
import { NewsItem } from '@/types/dashboard';
import { Link } from 'react-router-dom';

interface NewsCardProps {
  news: NewsItem[];
  isLoading: boolean;
}

export function NewsCard({ news, isLoading }: NewsCardProps) {
  const { t, language } = useLanguage();



  return (
    <Card className="border-border/50 h-full bg-card/50 backdrop-blur-sm hover:shadow-lg transition-all duration-300 hover:border-primary/50 flex flex-col">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl flex items-center">
          <div className="p-2 rounded-lg bg-primary/10 mr-3 group-hover:bg-primary/20 transition-colors">
            <Newspaper className="h-5 w-5 text-primary" />
          </div>
          <Link to="/news" className="hover:text-primary transition-colors flex-1">
            {t('dashboard.latest_news')}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 min-h-0 p-2 overflow-hidden">
        {isLoading ? (
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex flex-col gap-2">
                <div className="h-5 w-3/4 bg-secondary/50 animate-pulse rounded-md" />
                <div className="h-4 w-1/4 bg-secondary/30 animate-pulse rounded-md" />
              </div>
            ))}
          </div>
        ) : news && news.length > 0 ? (
          <div className="flex flex-col h-full gap-2">
            {news.map((newsItem: NewsItem, index: number) => (
              <div
                key={`${language}-news-${index}`}
                className="block group/item flex-1 min-h-0"
              >
                <NewsListItem news={newsItem} />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground text-sm">{t('common.no_results')}</p>
        )}
      </CardContent>
    </Card>
  );
}
